import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-missing-ufo',
  templateUrl: './missing-ufo.component.html',
  styleUrls: ['./missing-ufo.component.scss']
})
export class MissingUfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
